import { defineStore, acceptHMRUpdate } from 'pinia'
import { constantRouterMap } from '@/router/index'

export const useRouteStore = defineStore('route',{
  state: () => {
    return {
      addRouters: [],
      routeHistory:[]
    }
  },
  getters: {

  },
  actions: {
    setRouters(routers) {
      this.addRouters = routers
      constantRouterMap.reverse().forEach(v => this.addRouters.unshift(v))
    },
    setRouteHistory(routeHistory) {
      this.routeHistory = routeHistory
    },
    addRouteHistory(route){
      this.routeHistory.push(route)
    },
    removeRouteHistory(route){
      this.routeHistory = this.routeHistory.filter(r => r.name != route.name)
    },
    clearRouteHistory(){
      this.routeHistory=[];
    }
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useRouteStore, import.meta.hot))
}